import { useContext } from "react";

import { AuthenticationContext } from "../../providers/authentication/AuthenticationContext";
import { Button } from "../atoms";

function Footer() {
  const { logout } = useContext(AuthenticationContext);
  return (
    <footer className="mx-1">
      <div className="w-full p-4">
        <div className="flex items-center justify-between">
          <div className="text-left">
            Powered by{" "}
            <a href="https://www.gymflow.io" target="_blank" rel="noreferrer">
              Gymflow.io
            </a>
          </div>
          <div className="flex justify-end">
            <Button
              intent="link"
              onClick={() => {
                logout();
                // eslint-disable-next-line react-compiler/react-compiler
                window.location.href = "/";
              }}
            >
              Logout
            </Button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
